module.exports = __webpack_public_path__ + "static/media/logo_carrinhodecompras.0a909f47.svg";